<div class="row main">

  <!---728x90--->

  
  <div class="col-md-8 left">
    <div class="left-side-content">

      <a href="index.html"><img src="../../assets/img/maharah_logo.png"></a>

      <div class="row">
        <div class="col-md-7 col-sm-7">
          <div class="content-txt">
            <h2>Welcome to Maharah</h2>
            <p>Get a complete clear view to learn and explore reports, review important account stats and explore features
              that we recommand based on your activity.
            </p>
          </div>
          <!-- <img src="../../assets/img/illustration.png"> -->
        </div>
        <div class="col-md-5 col-sm-5">
          <img  height="30%" src="../../assets/img/illustration.png">
        </div>
      </div>

    </div>
  </div>
  <div class="col-sm-12 col-md-12 col-lg-4 col-lg-4" >
    <!-- content -->
    <div class="sub-main-w3">
      <h3>Dashboard Login</h3>
      <p>Please sign in with your email id and password incorporated with your Maharah Account..
      </p>
      <!-- <form action="#" method="post" autocomplete="off"> -->
        <div class="form-style-agile">
          <div class="pom-agile">
            <input placeholder="Username" autocomplete="false" [(ngModel)]="form.username" name="username" type="text" required="">
          </div>
        </div>
        <div class="form-style-agile">
          <div class="pom-agile">
            <input placeholder="Password" autocomplete="false" type="password" [(ngModel)]="form.password" name="password" id="password1" required="">
          </div>
        </div>
        <button type="submit" class="btn btn-warning" (click)="validate()">Submit</button>
        <!-- <input type="submit" value="Submit" (click)="validate()"> -->
        <!-- <button type="submit" mat-raised-button color="primary" [class.spinner]="loading" [disabled]="loading" (click)="validate()">
          submit </button> -->
      <!-- </form> -->
    </div>
  </div>
</div>